import _regeneratorRuntime from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(iterator),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(iterator1);

import { NO_OP, SEMAPHORE } from "@thi.ng/api";
import { isIterable } from "@thi.ng/checks";
import { isReduced, unreduced } from "./reduced";
import { push } from "./rfn/push";
/**
 * Takes a transducer and input iterable. Returns iterator of
 * transformed results.
 *
 * @param xform
 * @param xs
 */

export function iterator(xform, xs) {
  var rfn, complete, reduce, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x, y;

  return _regeneratorRuntime.wrap(function iterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          rfn = xform(push());
          complete = rfn[1];
          reduce = rfn[2];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 6;
          _iterator = xs[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 19;
            break;
          }

          x = _step.value;
          y = reduce([], x);

          if (!isReduced(y)) {
            _context.next = 14;
            break;
          }

          return _context.delegateYield(unreduced(complete(y.deref())), "t0", 13);

        case 13:
          return _context.abrupt("return");

        case 14:
          if (!y.length) {
            _context.next = 16;
            break;
          }

          return _context.delegateYield(y, "t1", 16);

        case 16:
          _iteratorNormalCompletion = true;
          _context.next = 8;
          break;

        case 19:
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t2 = _context["catch"](6);
          _didIteratorError = true;
          _iteratorError = _context.t2;

        case 25:
          _context.prev = 25;
          _context.prev = 26;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 28:
          _context.prev = 28;

          if (!_didIteratorError) {
            _context.next = 31;
            break;
          }

          throw _iteratorError;

        case 31:
          return _context.finish(28);

        case 32:
          return _context.finish(25);

        case 33:
          return _context.delegateYield(unreduced(complete([])), "t3", 34);

        case 34:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[6, 21, 25, 33], [26,, 28, 32]]);
}
/**
 * Optimized version of `iterator()` for transducers which are
 * guaranteed to:
 *
 * 1) Only produce none or a single result per input
 * 2) Do not require a `completion` reduction step
 *
 * @param xform
 * @param xs
 */

export function iterator1(xform, xs) {
  var reduce, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, x, y;

  return _regeneratorRuntime.wrap(function iterator1$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          reduce = xform([NO_OP, NO_OP, function (_, x) {
            return x;
          }])[2];
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context2.prev = 4;
          _iterator2 = xs[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context2.next = 21;
            break;
          }

          x = _step2.value;
          y = reduce(SEMAPHORE, x);

          if (!isReduced(y)) {
            _context2.next = 15;
            break;
          }

          y = unreduced(y.deref());

          if (!(y !== SEMAPHORE)) {
            _context2.next = 14;
            break;
          }

          _context2.next = 14;
          return y;

        case 14:
          return _context2.abrupt("return");

        case 15:
          if (!(y !== SEMAPHORE)) {
            _context2.next = 18;
            break;
          }

          _context2.next = 18;
          return y;

        case 18:
          _iteratorNormalCompletion2 = true;
          _context2.next = 6;
          break;

        case 21:
          _context2.next = 27;
          break;

        case 23:
          _context2.prev = 23;
          _context2.t0 = _context2["catch"](4);
          _didIteratorError2 = true;
          _iteratorError2 = _context2.t0;

        case 27:
          _context2.prev = 27;
          _context2.prev = 28;

          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }

        case 30:
          _context2.prev = 30;

          if (!_didIteratorError2) {
            _context2.next = 33;
            break;
          }

          throw _iteratorError2;

        case 33:
          return _context2.finish(30);

        case 34:
          return _context2.finish(27);

        case 35:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[4, 23, 27, 35], [28,, 30, 34]]);
}
/**
 * Helper function used by various transducers to wrap themselves as
 * transforming iterators. Delegates to `iterator1()` by default.
 *
 * @param xform
 * @param args
 * @param impl
 */

export var $iter = function $iter(xform, args) {
  var impl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : iterator1;
  var n = args.length - 1;
  return isIterable(args[n]) ? args.length > 1 ? impl(xform.apply(null, args.slice(0, n)), args[n]) : impl(xform(), args[0]) : undefined;
};